import { AboutUsTabsForm } from "./about-us-tabs-form";
import { AboutUsTabsHandler } from "./about-us-tabs-handler";
import { AboutUsTabsListener } from "./about-us-tabs-listener";

export class AboutUsTabsSetup {
    private readonly form: AboutUsTabsForm;

    private readonly handler: AboutUsTabsHandler;

    private readonly listener: AboutUsTabsListener;

    public constructor(root: HTMLElement) {
        this.form = new AboutUsTabsForm(root);
        this.handler = new AboutUsTabsHandler(this.form);
        this.listener = new AboutUsTabsListener(this.form, this.handler);
    }

    private initInstance(): void {
        if (this.form.isInitialized()) return;
        this.form.markInitialized();
        this.listener.register();
        this.handler.bootstrap();
    }

    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLElement)) return;
        new AboutUsTabsSetup(root).initInstance();
    }
}
